import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { VALIDATION_RULES } from "@/constants/ValidationRules";
import { Prop } from "vue-property-decorator";
import _ from "lodash";
let AddKidSchoolFormForm = class AddKidSchoolFormForm extends Vue {
    kidSchoolId = null;
    dataSource;
    dialog = false;
    errorMessage = '';
    hour;
    duration = 100;
    pricePerKid = 600;
    age = '3 - 11';
    capacity = 15;
    isPremium = false;
    instructorsCount = 7;
    isPrepaidOnly = false;
    leaderId;
    hourRules = [
        VALIDATION_RULES.REQUIRED,
    ];
    durationRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    pricePerKidRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    ageRules = [
        VALIDATION_RULES.REQUIRED,
    ];
    capacityRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    instructorsCountRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    maxCapacity = 20;
    created() {
        this.hour = { hour: 9, minute: 20 };
    }
    async open(school) {
        this.reset();
        await this.$nextTick();
        this.kidSchoolId = school?.id ?? null;
        this.age = school?.age ?? '3 - 11';
        this.capacity = school?.capacity ?? 15;
        this.hour = school ? `${school.hourFrom}:${school.minuteFrom < 10 ? `0${school.minuteFrom}` : school.minuteFrom}` : '09:20';
        this.duration = school?.duration ?? 100;
        this.pricePerKid = school?.pricePerKid ?? 600;
        this.isPremium = school?.isPremium ?? false;
        this.instructorsCount = school?.instructorMaxCount ?? 7;
        this.isPrepaidOnly = school?.isPrepaidOnly ?? false;
        this.leaderId = school?.leaderId;
        this.dialog = true;
    }
    async submit() {
        if (this.hour === undefined) {
            return;
        }
        if (!this.$refs.form.validate()) {
            return;
        }
        const date = _.cloneDeep(this.dataSource.date).set({ hour: this.hour.split(':')[0], minute: this.hour.split(':')[1] });
        if (this.kidSchoolId) {
            await this.$store.dispatch('kidSchool/update', {
                id: this.kidSchoolId,
                capacity: this.capacity,
                datetime: date.format('YYYY-MM-DD HH:mm:ss'),
                length: this.duration,
                center: process.env.VUE_APP_AREAL_ID,
                age: this.age,
                price: this.pricePerKid,
                isPremium: this.isPremium,
                instructorsCount: this.instructorsCount,
                isPrepaidOnly: this.isPrepaidOnly,
                leaderId: this.leaderId,
            });
        }
        else {
            await this.$store.dispatch('kidSchool/store', {
                capacity: this.capacity,
                datetime: date.format('YYYY-MM-DD HH:mm:ss'),
                length: this.duration,
                center: process.env.VUE_APP_AREAL_ID,
                age: this.age,
                price: this.pricePerKid,
                isPremium: this.isPremium,
                instructorsCount: this.instructorsCount,
                isPrepaidOnly: this.isPrepaidOnly,
            });
        }
        this.dialog = false;
        this.$emit('submit');
    }
    cancel() {
        this.reset();
        this.dialog = false;
    }
    reset() {
        this.kidSchoolId = null;
        this.leaderId = undefined;
        if (this.$refs.form) {
            this.$refs.form.reset();
        }
    }
    get dateString() {
        return this.dataSource.date.format("DD. MM. YYYY");
    }
    get isEditing() {
        return this.kidSchoolId !== null;
    }
};
__decorate([
    Prop({ required: true })
], AddKidSchoolFormForm.prototype, "dataSource", void 0);
AddKidSchoolFormForm = __decorate([
    Component
], AddKidSchoolFormForm);
export default AddKidSchoolFormForm;
